import Axios, { AxiosInstance, Method } from 'axios'
import { RequestError } from 'src/common-services'
import qs from 'qs'

export type CompanyPayload = {
  name: string
  domain: string
  logo: string
}

export type GetSuggestParams = {
  query: string
}

export class CompaniesClient {
  private readonly axios: AxiosInstance
  protected readonly baseUrl: string = 'https://autocomplete.clearbit.com/v1/companies'
  protected readonly timeout = 1000

  constructor() {
    this.axios = Axios.create({
      baseURL: this.baseUrl,
      timeout: this.timeout,
      paramsSerializer(params) {
        return qs.stringify(params)
      },
    })
  }

  protected async post<T>(url: string, data: any): Promise<T> {
    return this.call<T>(url, 'POST', { data })
  }

  protected async call<T>(
    url: string,
    method: Method,
    request?: { params?: any; data?: any; responseType?: any }
  ): Promise<T> {
    try {
      const req = {
        method,
        params: request?.params,
        data: request?.data,
        responseType: request?.responseType,
        url,
      }
      const response = await this.axios.request(req)
      return response.data as T
    } catch (error: any) {
      const message = error.response?.data?.error || error.message
      throw new RequestError(message, error.response?.status, error)
    }
  }

  public async getSuggest(request: GetSuggestParams): Promise<CompanyPayload[]> {
    return this.call<CompanyPayload[]>('/suggest', 'GET', { params: request })
  }
}
